import StopIcon from '../core/icons/Stop';
import SecondaryButton from '../core/SecondaryButton';
import { Typography } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { globalStyles as styles } from '../core/style/gstheme';
import TitledPanel from '../core/TitledPanel';

class CheckingStatus extends React.Component {

    state = {
        stopped: false
    };

    onStop = () => {
        this.setState({ stopped: true });
        this.props.onStop();
    };

    render() {

        const { progressCount, itemCount, checksSuccessful, classes, onStop, checksInconclusive } = this.props;
        const { stopped } = this.state;

        return (
            <div>
                <TitledPanel title={undefined}>
                    <div style={{ height: onStop ? '120px' : '93px', paddingTop: '40px' }}>
                        {progressCount < itemCount &&
                            <Typography
                                data-test="check-progress"
                                color="secondary"
                                paragraph
                                role="status"
                                className={classes.mainHeading}
                                align="center">{progressCount}/{itemCount} Checks Completed</Typography>
                        }
                        {progressCount === itemCount &&
                            (checksInconclusive ?
                                <Typography
                                    paragraph
                                    role="status"
                                    className={classes.mainHeadingSecondary}
                                    style={{ color: '#CA4F0C' }}
                                    align="center">
                                    <WarningIcon
                                        data-test="checks-inconclusive"
                                        fontSize="large"
                                        style={{ verticalAlign: 'middle', marginRight: '10px' }} />Checks Inconclusive ({itemCount} run)</Typography>
                                :
                                checksSuccessful ?
                                    <Typography
                                        paragraph
                                        role="status"
                                        className={classes.mainHeadingSecondary}
                                        style={{ color: '#50832C' }}
                                        align="center">
                                        <CheckCircleIcon
                                            data-test="checks-passed"
                                            fontSize="large"
                                            color="secondary"
                                            style={{ verticalAlign: 'middle', marginRight: '10px' }} />Checks Successful ({itemCount} run)</Typography>
                                    :
                                    <Typography
                                        data-test="checks-failed"
                                        paragraph
                                        role="status"
                                        className={classes.mainHeading}
                                        style={{ color: '#DD2C00' }}
                                        align="center">
                                        <WarningIcon
                                            data-test="checks-failed"
                                            fontSize="large"
                                            style={{ verticalAlign: 'middle', marginRight: '10px' }} />Checks Failed ({itemCount} run)</Typography>

                            )
                        }
                        <div style={{ marginLeft: 6 }}>
                            <LinearProgress
                                aria-label="Progress"
                                color="secondary"
                                className={classes.progress}
                                variant="determinate"
                                value={progressCount / itemCount * 100} />
                        </div>
                        {!stopped && onStop && progressCount < itemCount &&
                            <div style={{ textAlign: 'center', marginTop: 12, marginBottom: 12 }}>
                                <SecondaryButton
                                    dataTest="stop-checks"
                                    onClick={this.onStop}
                                    endIcon={<StopIcon />}
                                    className={classes.button}>Stop Checks</SecondaryButton>
                            </div>
                        }
                        {stopped &&
                            <div style={{ textAlign: 'center', marginTop: 12, marginBottom: 12 }}>
                                <Typography
                                    data-test="checks-halted"
                                    paragraph
                                    role="status"
                                    className={classes.mainHeading}
                                    align="center">Checks Stopped</Typography>
                            </div>
                        }
                    </div>
                </TitledPanel>
            </div>
        );
    }
}

CheckingStatus.defaultProps = {
    itemCount: 0,
    progressCount: 0,
    checksSuccessful: false,
    checksInconclusive: false
};

CheckingStatus.propTypes = {
    itemCount: PropTypes.number.isRequired,
    progressCount: PropTypes.number,
    checksInconclusive: PropTypes.bool,
    checksSuccessful: PropTypes.bool.isRequired,
    classes: PropTypes.object,
    onStop: PropTypes.func
};

export default withStyles(styles)(withRouter(CheckingStatus));